import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { CommonApiService } from "src/app/services/common-api.service";
import { IAppAppearance } from "../../models/white-labeling.model";
import { wlbActions } from "./white-labeling.actions.list";
import { WhiteLabelService } from "src/app/services/white-label.service";
import { defaultWhiteLabel } from "src/app/app-data/initialwlb.data";
import { API } from "../../models/api.enum";

export const whiteLabelingEffect = createEffect(
  (actions$ = inject(Actions), api = inject(CommonApiService)) => {
    return actions$.pipe(
      ofType(wlbActions.load),
      exhaustMap((action) => {
        const url = API.WHITELABEL_API_BRANDING_GET
          .replace("{{ userId }}", action.userId)
          .replace("{{ orgId }}", action.orgId);
        return api.get<IAppAppearance>(url).pipe(
          map((response) => wlbActions.success({ response })),
          catchError((error) => of(wlbActions.failure({ error }))),
        );
      }),
    );
  },
  { functional: true },
);

export const applyWhiteLabelingEffect = createEffect(
  (actions$ = inject(Actions), whiteLabelService = inject(WhiteLabelService)) =>
    actions$.pipe(
      ofType(wlbActions.success),
      tap((action) => {
        const { response } = action as ReturnType<typeof wlbActions.success>;
        if (response && Object.keys(response).length > 0) {
          whiteLabelService.applyWhiteLabeling(response);
        } else {
          whiteLabelService.applyWhiteLabeling({ ...defaultWhiteLabel });
        }
      }),
    ),
  { functional: true, dispatch: false },
);
